
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Cutaneous_melanoma",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Cutaneous_melanoma.vue